import * as React from 'react'
import moment from 'moment'
import { DatePicker, Icon } from 'antd'
import { RangePickerPresetRange, RangePickerValue } from 'antd/lib/date-picker/interface'

interface Props {
  startDate?: Date | null
  endDate?: Date | null
  flexDirection?: 'row' | 'column'
  wrapperClassName?: string
  dateClassName?: string
  wrapperStyle?: React.CSSProperties
  allowClear?: boolean
  getPopupContainer?: (triggerNode: Element) => HTMLElement
  onStartDateChange: (date: Date | null) => void
  onEndDateChange: (date: Date | null) => void
  onClose?: () => void
  presets?: { [range: string]: RangePickerPresetRange }
  maxRangeMonths?: number
}

export class DateFilter extends React.Component<Props, {}> {
  onRangeChange = (dates: RangePickerValue) => {
    const [selectedStartDate, selectedEndDate] = dates
    this.props.onStartDateChange(
      selectedStartDate ? selectedStartDate.startOf('day').toDate() : null,
    )
    this.props.onEndDateChange(selectedEndDate ? selectedEndDate.endOf('day').toDate() : null)
  }

  get presets(): { [range: string]: RangePickerPresetRange } {
    if (this.props.presets) {
      return this.props.presets
    }

    const commonPresets: { [key: string]: () => RangePickerValue } = {
      Today: () => [moment().startOf('day'), moment().endOf('day')],
      Yesterday: () => [
        moment().subtract(1, 'day').startOf('day'),
        moment().subtract(1, 'day').endOf('day'),
      ],
      '2 days ago': () => [
        moment().subtract(2, 'day').startOf('day'),
        moment().subtract(2, 'day').endOf('day'),
      ],
      'This week': () => [moment().startOf('week'), moment()],
      'Last week': () => [
        moment().subtract(1, 'week').startOf('week'),
        moment().subtract(1, 'week').endOf('week'),
      ],
      '2 weeks ago': () => [
        moment().subtract(2, 'week').startOf('week'),
        moment().subtract(2, 'week').endOf('week'),
      ],
      'This month': () => [moment().startOf('month'), moment()],
      'Last month': () => [
        moment().subtract(1, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month'),
      ],
      '2 months ago': () => [
        moment().subtract(2, 'month').startOf('month'),
        moment().subtract(2, 'month').endOf('month'),
      ],
    }

    const maxRangeMonths = this.props.maxRangeMonths || 0
    if (maxRangeMonths >= 12) {
      commonPresets['This year'] = () => [moment().startOf('year'), moment()]
      commonPresets['Last year'] = () => [
        moment().subtract(1, 'year').startOf('year'),
        moment().subtract(1, 'year').endOf('year'),
      ]
    }
    return commonPresets
  }

  get defaultRangeDates(): RangePickerValue | undefined {
    const { startDate, endDate } = this.props

    return startDate && endDate ? [moment(startDate), moment(endDate)] : undefined
  }

  render() {
    const {
      getPopupContainer,
      wrapperClassName,
      dateClassName,
      allowClear,
      wrapperStyle,
      flexDirection,
      onClose,
    } = this.props

    return (
      <div
        className={wrapperClassName}
        style={{
          display: 'flex',
          flexDirection: flexDirection || 'column',
          ...wrapperStyle,
        }}
      >
        <DatePicker.RangePicker
          className={dateClassName}
          ranges={this.presets}
          format={['MMM D, YYYY']}
          value={this.defaultRangeDates}
          getCalendarContainer={getPopupContainer}
          allowClear={allowClear}
          onChange={this.onRangeChange}
        />

        {onClose && (
          <Icon
            type='close'
            onClick={onClose}
            className='text-muted rounded cursor-pointer gr-filter-close-button'
          />
        )}
      </div>
    )
  }
}
